// extracted by mini-css-extract-plugin
export default {"container":"card_container__fak2e","clicked":"card_clicked__6MoMa","text":"card_text__z4gkk","year":"card_year__DpnVS"};